import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\CommissionNote\DeleteCommissionNoteController::__invoke
* @see app/Http/Controllers/CommissionNote/DeleteCommissionNoteController.php
* @route '/api/commission-note/{commission_note}'
*/
const DeleteCommissionNoteController = (args: { commission_note: string | number | { id: string | number } } | [commission_note: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteCommissionNoteController.url(args, options),
    method: 'delete',
})

DeleteCommissionNoteController.definition = {
    methods: ["delete"],
    url: '/api/commission-note/{commission_note}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\CommissionNote\DeleteCommissionNoteController::__invoke
* @see app/Http/Controllers/CommissionNote/DeleteCommissionNoteController.php
* @route '/api/commission-note/{commission_note}'
*/
DeleteCommissionNoteController.url = (args: { commission_note: string | number | { id: string | number } } | [commission_note: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { commission_note: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { commission_note: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            commission_note: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        commission_note: typeof args.commission_note === 'object'
        ? args.commission_note.id
        : args.commission_note,
    }

    return DeleteCommissionNoteController.definition.url
            .replace('{commission_note}', parsedArgs.commission_note.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CommissionNote\DeleteCommissionNoteController::__invoke
* @see app/Http/Controllers/CommissionNote/DeleteCommissionNoteController.php
* @route '/api/commission-note/{commission_note}'
*/
DeleteCommissionNoteController.delete = (args: { commission_note: string | number | { id: string | number } } | [commission_note: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteCommissionNoteController.url(args, options),
    method: 'delete',
})

export default DeleteCommissionNoteController